import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import snackbarReducer from 'store/slices/snackbar';
import userReducer from 'store/slices/apiV1/user';
import menuReducer from 'store/slices/menu';
import orgReducer from 'store/slices/apiV1/org';
import datagridReducer from 'store/slices/datagrid';
import sessionReducer from 'store/slices/apiV1/session';
import partStatusReducer from 'store/slices/apiV1/partStatus';
import partDataReducer from 'store/slices/apiV1/partData';
import utilityReducer from 'store/slices/apiV1/utility';
import detailDrawerReducer from 'store/slices/detailDrawer';
import cartPreferencesReducer from 'store/slices/cartPreferences';
import { apiSlice } from 'store/slices/api';

const reducer = combineReducers({
  snackbar: snackbarReducer,
  user: persistReducer({ key: 'user', storage }, userReducer),
  menu: menuReducer,
  org: persistReducer(
    {
      key: 'org',
      storage,
      whitelist: [
        'activeOrgId',
        'blended',
        'sandbox',
        'activeOrg',
        'punchoutId',
      ],
    },
    orgReducer
  ),
  detailDrawer: persistReducer(
    {
      key: 'detailDrawer',
      storage,
      whitelist: ['open'],
    },
    detailDrawerReducer
  ),
  datagrid: persistReducer(
    {
      key: 'datagrid',
      storage,
    },
    datagridReducer
  ),
  [apiSlice.reducerPath]: apiSlice.reducer,
  session: persistReducer(
    {
      key: 'session',
      storage,
      whitelist: [
        'authToken',
        'refreshToken',
        'storedLocation',
        'storedOrg',
        'isLoggedIn',
      ],
    },
    sessionReducer
  ),
  partStatus: partStatusReducer,
  partData: partDataReducer,
  utility: persistReducer(
    {
      key: 'utility',
      storage: storageSession,
      blacklist: ['showNoPlanBanner'],
    },
    utilityReducer
  ),
  cartPreferences: persistReducer(
    {
      key: 'cartPreferences',
      storage: storageSession,
    },
    cartPreferencesReducer
  ),
});

export default reducer;
